// John Eldhose 20190110
import { RestfulGet } from './Restful';

export async function getLMDProds() {
  const prods = await RestfulGet('getLMDProds', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return prods;
}



// WEBPACK FOOTER //
// ./src/Api/getLMDProds.js